<app-banner></app-banner>




  <div class="contenedorMain">
    <div class="contenedorChild">


      <div class="row">
        <div class="col-md-6">
          <h3 class="titleBien">Bienvenido,</h3>
        </div>
      </div>


      <div class="row">

        <div class="col-md-8">
          <h1 class="nameTitle">{{nombres}}</h1>
        </div>
      
      <!--  <div class="col-md-2">
          {{rol}}
        </div> -->
      </div>
      <br>
      <div class="row"  *ngIf="esAdministrado">
        <div class="col-4">
          <h5 class="escaneos">Escaneos | Total: {{cantidad_registro}}</h5>
        </div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <!-- <div class="col-md-4">    <h2>Escaneos|Total: {{cantidad_registro}}</h2>
      </div>-->
      </div>
      <br>
      <div class="row"  *ngIf="esAdministrado">
        <div class="col-md-6">

          <div class="tableMain">
          <table class="table table-responsive">
            <thead style="z-index: 9999;">
              <tr class="table-secondary" style="border-radius: 50">
                <th scope="col" >#</th>
                <th scope="col" >País</th>
                <th scope="col" >Visitas</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let result of List_Cantidad_Visitas; let i = index"  >
                <th scope="row" >{{ i + 1 }}</th>
                <th scope="row" >{{result.country}}</th>
                <th scope="row" >{{result.count_cantidad}}</th>

              </tr>
            </tbody>
          </table>
        </div>
        </div>
        <div class="col-md-6">
          <div id="container1" style="width: 100%; height: 380px;"></div>
        </div>


      </div>


    </div>
  </div>

  <app-footer></app-footer>